import { all } from 'redux-saga/effects'
import { socketSaga } from './socket/sagas'

export function* userSaga() {
  yield all([socketSaga()])
}
